var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',_vm._b({},'router-view',{
      images: _vm.imageStore,
      lists: _vm.listStore,
      trackers: _vm.trackerStore,
      svgs: _vm.svgStore,
      pages: _vm.pages
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }